import {
  OutsideEnrollmentAreaStatus,
  RequestData,
} from "../../../models/Request";

export const getEnrollmentInstitutionDisplayName = (item: RequestData) => {

  if (item.enrollmentInstitutionName) return item.enrollmentInstitutionName;
  
  if (
    item.outsideEnrollmentAreaStatus ===
    OutsideEnrollmentAreaStatus.DecisionAccepted
  )
    return item.outsideEnrollmentAreaInstitutionName ?? "";
  
    if (
    item.outsideEnrollmentAreaStatus ===
    OutsideEnrollmentAreaStatus.DecisionDeclined
  )
    return item.institutionName ?? "";

  return "";
};
